import { action, makeAutoObservable, makeObservable, observable } from 'mobx';
import {
  ExternalNotification,
  LocalNotification,
} from '../../../../shared/infrastructure/types/common/common-types';

class BaseNotificator {
  localNotifications: LocalNotification[];
  externalNotifications: ExternalNotification[];
  private lala = '';

  constructor() {
    // limitations for extending subclasses, see https://mobx.js.org/subclassing.html
    makeObservable<BaseNotificator>(this, {
      localNotifications: observable,
      externalNotifications: observable,
      pushLocal: action,
      popLocal: action,
      pushExternal: action,
      popExternal: action,
      // lala: observable,
    });

    this.localNotifications = [];
    this.externalNotifications = [];
  }

  pushLocal(notification: LocalNotification) {
    this.localNotifications.push(notification);
  }

  popLocal() {
    return this.localNotifications.pop();
  }

  pushExternal(notification: ExternalNotification) {
    this.externalNotifications.push(notification);
  }

  popExternal() {
    return this.externalNotifications.pop();
  }
}

export { BaseNotificator };
